import React, { useState } from "react";
import PropTypes from "prop-types";
import { Form, Input, Button, Select, message, Upload } from "antd";
import { useFormik } from "formik";
import { isEmpty } from "lodash";
import CategoryCreationSchema from "../../../../Schemas/CategoryCreationSchema";

import {
  createCategory,
  updateCategory,
} from "../../../../Services/CategoryService";
import { useHistory } from "react-router-dom"; // useHistory for v5

function CategoryCreationForm({
  data = {},
  callReFetch,
  isEditMode = false,
  onClose,
}) {
  const formik = useFormik({
    initialValues: {
      name: data.name || "",
      code: data.code || "",
    },
    enableReinitialize: true,
    validationSchema: CategoryCreationSchema,
  });

  const [loading, setLoading] = useState(false);
  const history = useHistory(); // useHistory for v5

  const handleSubmit = async () => {
    const values = formik.values;
    if (isEmpty(values.name) || isEmpty(values.code)) {
      message.error("Please insert all required data.");
      return;
    }

    try {
      if (!isEditMode) {
        await createCategory(values);
        message.success("Category created successfully");
        onClose();
        callReFetch();
        formik.resetForm();
        // Redirect to the category list or wherever you want
      } else {
        const updatedCategory = await updateCategory(data._id, values);
        callReFetch();
        message.success(
          updatedCategory?.data?.message || "Category updated successfully"
        );
        onClose(); // Close the modal
      }
    } catch (err) {
      console.error("Error: ", err);
      message.error(err?.response?.data?.message || "Something went wrong.");
    }
  };

  const { values } = formik;
  const titleText = isEditMode ? "Category Detail" : "Create Category";
  const submitButtonText = isEditMode ? "Update" : "Create";

  return (
    <div>
      <h2
        className="title"
        style={{ display: "flex", justifyContent: "center" }}
      >
        {titleText}
      </h2>
      <p style={{ display: "flex", justifyContent: "center" }}>
        Nama & Code Tidak boleh duplicate
      </p>
      <p style={{ display: "flex", justifyContent: "center" }}>
        Code hanya di antara 00 - 99
      </p>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Form
          layout="vertical"
          style={{
            maxWidth: "80vw",
            backgroundColor: "#F5F5F5",
            borderRadius: "8px",
            padding: "16px",
          }}
        >
          <Form.Item label="Name" required>
            <Input
              style={{ width: "100%" }}
              placeholder="Enter category name"
              onChange={(e) => formik.setFieldValue("name", e.target.value)}
              value={values.name}
            />
          </Form.Item>
          <Form.Item label="Code" required>
            <Input
              name="code"
              placeholder="Enter brand code"
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  // Allows only numbers (0-9)
                  let num = Number(value);
                  if (num >= 0 && num <= 99) {
                    let formattedValue = num.toString().padStart(2, "0"); // Ensures 3-digit format
                    formik.setFieldValue("code", formattedValue);
                  }
                }
              }}
              value={formik.values.code}
            />
          </Form.Item>{" "}
          <Form.Item style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="button"
              className="bg-black"
              onClick={handleSubmit}
              style={{ marginRight: "10px" }}
            >
              {submitButtonText}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}

CategoryCreationForm.propTypes = {};

export default CategoryCreationForm;
